function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import cn from 'classnames';
import GlucoseLevelsSlider from 'components/Sliders/GlucoseLevelsSlider';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import messages from '../../messages';
import styles from './GlucoseLevelTargets.pcss';
var _React_PureComponent;
class TargetsPicker extends (_React_PureComponent = React.PureComponent) {
    render() {
        const { header, targetType, formValues, locked, countrySettings, withoutOrder } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('mb-4', styles.targetsPicker, {
                [styles.withoutBorder]: withoutOrder
            }),
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "brand__paragraph--bold title",
                    role: "presentation",
                    children: header
                }),
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(GlucoseLevelsSlider, _object_spread_props(_object_spread({}, this.props), {
                                locked: locked,
                                countrySettings: countrySettings
                            }))
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ _jsx(FormGroup, {
                                    className: "col-6 mb-0",
                                    id: `${targetType}_lowThreshold`,
                                    labelMessage: messages.labels.glucoseLow,
                                    formValues: formValues,
                                    isDisabled: locked,
                                    children: /*#__PURE__*/ _jsx(Input, {
                                        type: "number",
                                        id: `${targetType}_lowThreshold`,
                                        placeholder: messages.labels.glucoseLow,
                                        onChange: (input)=>this.props.onRangeChange(input),
                                        isDisabled: locked
                                    })
                                }),
                                /*#__PURE__*/ _jsx(FormGroup, {
                                    className: "col-6 mb-0",
                                    id: `${targetType}_highThreshold`,
                                    labelMessage: messages.labels.glucoseHigh,
                                    formValues: formValues,
                                    isDisabled: locked,
                                    children: /*#__PURE__*/ _jsx(Input, {
                                        type: "number",
                                        id: `${targetType}_highThreshold`,
                                        placeholder: messages.labels.glucoseHigh,
                                        onChange: (input)=>this.props.onRangeChange(input),
                                        isDisabled: locked
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
_define_property(TargetsPicker, "propTypes", {
    // Explicit props
    header: PropTypes.node,
    valueMin: PropTypes.number,
    valueMax: PropTypes.number,
    valueStep: PropTypes.number,
    valueDragStep: PropTypes.number,
    formValues: PropTypes.object,
    conversion: PropTypes.object,
    locked: PropTypes.bool,
    targetType: PropTypes.string,
    countrySettings: PropTypes.object,
    precision: PropTypes.number,
    phiSet: PropTypes.object,
    withoutOrder: PropTypes.bool,
    // Explicit actions
    onRangeChange: PropTypes.func
});
_define_property(TargetsPicker, "defaultProps", {
    valueMin: 0,
    valueMax: 300,
    valueStep: 50,
    valueDragStep: 1,
    locked: false,
    targetType: '',
    precision: 0
});
export default withStyles(styles)(TargetsPicker);
